import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './contactPointSearcher.module.scss';
import { CustomLink, Image } from '../..';
import images from '../../../assets/images/images';
import { IContactPointViewItem } from '../../../interfaces';
import { Button } from '../../Button/Button';

interface ITileViewProps {
    onViewLineClick?: (view: IContactPointViewItem, event: React.SyntheticEvent, back?: boolean) => void;
    selectedContactStack?: IContactPointViewItem[];
    searchValue?: string;
    contact: IContactPointViewItem;
}

const TileView = ({ contact, onViewLineClick }: ITileViewProps): JSX.Element => {
    const [isReadMore, setIsReadMore] = useState(true);
    const charLength = 90;
    const enableInfoReport = contact?.contactPoint?.reportLink;

    const shouldDisplayDescription = contact?.description || contact?.contactPoint?.reportLink?.description;

    const DescriptionText = (description: string): string => {
        if (isReadMore && description?.length >= charLength) {
            return `${description.substring(0, charLength)}...`;
        }
        return description;
    };

    const toggleReadMore = (event: React.SyntheticEvent): void => {
        event.stopPropagation();
        setIsReadMore(!isReadMore);
    };

    return (
        <div className={styles.tileWrapper} key={contact.id} onClick={(event): void => onViewLineClick(contact, event)}>
            <p className={`m-0 ${styles.tileHeader}`}>{contact.name}</p>
            {!shouldDisplayDescription ? null : (
                <>
                    <p id="contact-description" className={`m-0 ${styles.tileContent}`}>
                        {DescriptionText(contact.description)}
                    </p>
                    {enableInfoReport && (
                        <div>
                            <div className="my-1">
                                <div>
                                    <strong>{contact.contactPoint?.reportLink?.label}</strong>
                                </div>

                                <div>{contact.contactPoint?.reportLink?.description}</div>
                            </div>

                            <div className="mt-3">
                                <CustomLink
                                    href={contact.contactPoint?.reportLink?.externalLink}
                                    target="_blank"
                                    className="d-inline-block"
                                    onClick={(e): void => e.preventDefault()}
                                >
                                    {contact.contactPoint?.reportLink?.externalLinkText}
                                </CustomLink>
                            </div>
                        </div>
                    )}
                </>
            )}
            <div className={styles.tileFooter}>
                <div>
                    {contact.description.length > charLength && (
                        <div id="read-more" onClick={toggleReadMore}>
                            <FormattedMessage id={isReadMore ? 'READ_MORE' : 'READ_LESS'} />
                            <Image
                                src={isReadMore ? images.chevronDown : images.chevronUp}
                                className={styles.chevronIcon}
                                alt="ChevronIcon"
                            />
                        </div>
                    )}
                </div>
                {contact.contactPoint ? (
                    <div className={styles.tileSelectFooter}>
                        <Button variant="solid" className={styles.tileSelectButton}>
                            <FormattedMessage id="SELECT" />
                        </Button>
                    </div>
                ) : (
                    <Image src={images.arrowForward} alt="arror forward" />
                )}
            </div>
        </div>
    );
};

export default TileView;
